<template>
<div>
    <div class="bg-gradient"></div>
    <div class="main-page">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="search-holder mt-30 search-holder-list">
                        <div class="input-group">
                            <!-- <input type="text" class="form-control rounded-right" placeholder="Search Enquiry" /> -->
                            <input type="text" placeholder="Search by executives name" @input="(e) => (Filter = e.target.value)" :value="Filter" class="search form-control" @keyup.enter="FilterData" />
                            <svg v-if="Filter" @click="resetFilter" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512.001 512.001" style="enable-background: new 0 0 512.001 512.001" xml:space="preserve" width="14" height="14" class="close r-70">
                                <g>
                                    <g>
                                        <path d="M284.286,256.002L506.143,34.144c7.811-7.811,7.811-20.475,0-28.285c-7.811-7.81-20.475-7.811-28.285,0L256,227.717
                            L34.143,5.859c-7.811-7.811-20.475-7.811-28.285,0c-7.81,7.811-7.811,20.475,0,28.285l221.857,221.857L5.858,477.859
                            c-7.811,7.811-7.811,20.475,0,28.285c3.905,3.905,9.024,5.857,14.143,5.857c5.119,0,10.237-1.952,14.143-5.857L256,284.287
                            l221.857,221.857c3.905,3.905,9.024,5.857,14.143,5.857s10.237-1.952,14.143-5.857c7.811-7.811,7.811-20.475,0-28.285
                            L284.286,256.002z" />
                                    </g>
                                </g>
                            </svg>
                            <div class="input-group-append align-fix" id="button-addon4">
                                <!-- <button class="btn btn-white rounded-right" :disabled="!Filter" @click="FilterData" type="button">Go</button> -->
                                <button class="btn btn-white rounded-right" :disabled="!Filter" @click="FilterData" type="button">
                                    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 451 451" style="enable-background: new 0 0 451 451" xml:space="preserve">
                                        <g>
                                            <path d="M447.05,428l-109.6-109.6c29.4-33.8,47.2-77.9,47.2-126.1C384.65,86.2,298.35,0,192.35,0C86.25,0,0.05,86.3,0.05,192.3
                                        s86.3,192.3,192.3,192.3c48.2,0,92.3-17.8,126.1-47.2L428.05,447c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4
                                        C452.25,441.8,452.25,433.2,447.05,428z M26.95,192.3c0-91.2,74.2-165.3,165.3-165.3c91.2,0,165.3,74.2,165.3,165.3
                                        s-74.1,165.4-165.3,165.4C101.15,357.7,26.95,283.5,26.95,192.3z" />
                                        </g>
                                    </svg>
                                </button>
                                <button v-b-toggle.sidebar-right class="filter-menu btn btn-filter btn-white" type="button">
                                    <img src="@/assets/filter.svg" alt="" />
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <span class="result-Text">{{ pageStart }} - {{ pageEnd }} of {{ total }}</span>
                        </div>
                    </div>
                </div>
                <!-- Enquiry Card -->
                <div class="col-12">
                    <div class="card enquiry-card m-height">
                        <b-list-group class="list-group-flush">
                            <b-list-group-item :to="{ name: 'DailyStandUpDetails', params: {  id: item.id }}" v-for="item in GetAllMeetings" :key="item.id">
                                <div class="row">
                                    <div class="col-6 pr-1">
                                        <span class="name ellipses" v-if="item.field_executive">{{item.field_executive}}</span>
                                    </div>
                                    <div class="col-6 pl-1 text-right">
                                        <read-more more-str="read more" :text="item.comment" link="#" less-str="read less" :max-chars="50"></read-more>
                                        <!-- <span class="label label-tag" v-if="item.comment">{{item.comment}}</span> -->
                                    </div>
                                    <div class="col-12 pr-1">
                                        <span class="project-name" v-if="item.created_at !== null">{{`${item.created_at}`}}</span>
                                    </div>
                                </div>
                            </b-list-group-item>
                        </b-list-group>
                    </div>
                </div>
            </div>
            <router-link to="/AddDailyStandUpMeeting" class="float-btn" v-if="!isTimeExpired"><img src="@/assets/plus.svg" alt=""></router-link>
            <div class="pagination-holder">
                <paginate v-if="totalPages > 1" v-model="pageNo" :page-count="totalPages" :click-handler="goToPage" :page-class="'page-item'" :page-link-class="'page-link'" :prev-link-class="'page-link'" :next-link-class="'page-link'" :disabled-class="'page-item disabled'" :container-class="'pagination justify-content-center'">
                </paginate>
            </div>
            <b-sidebar id="sidebar-right" ref="sidebar-right" title="Advance Search" bg-variant="white" backdrop right shadow>
                <template v-slot="{ hide }">
                    <div class="card form-card sidebar-form-card">
                        <b-form @submit.prevent="AdvancedFilter" @reset="resetAdvancedFilter">
                            <b-form-group label="Team Lead">
                                <multiselect class="form-multiselect" v-model="AdvancedFilterMeeting.tl_id" :searchable="true" placeholder="Team Lead" label="full_name" track-by="id" :options="teamLeadList" :multiple="false" :taggable="false"></multiselect>
                            </b-form-group>
                            <b-form-group label="Executive">
                                <multiselect class="form-multiselect" v-model="AdvancedFilterMeeting.user_ids" :searchable="true" placeholder="Executive" label="full_name" track-by="id" :options="FieldExecutiveList" :multiple="true" :taggable="false"></multiselect>
                            </b-form-group>
                            <b-form-group label="Signed off">
                                <multiselect class="form-multiselect" v-model="AdvancedFilterMeeting.signing_off_done" :searchable="true" placeholder="sign-off" label="text" track-by="value" :options="VisitedList" :multiple="false" :taggable="false"></multiselect>
                            </b-form-group>
                            <b-form-group label="Created Date From">
                                <datetime type="datetime" v-model="AdvancedFilterMeeting.start_date" placeholder="Created Date From"></datetime>
                            </b-form-group>
                            <b-form-group label="Created Date To">
                                <datetime type="datetime" v-model="AdvancedFilterMeeting.end_date" placeholder="Created Date To"></datetime>
                            </b-form-group>

                            <!-- <b-form-group label="Categorization">
                  <multiselect class="form-multiselect" v-model="AdvancedFilterMeeting.categorization" :searchable="true" placeholder="Categorization" label="text" track-by="value" :options="broker_categorization" :multiple="true" :taggable="false"></multiselect>
                </b-form-group> -->
                            <b-form-group class="btn-fixed">
                                <b-button variant="primary" type="submit" block @click="hide">Search</b-button>
                                <b-button variant="primary-outline" block type="reset">Reset</b-button>
                            </b-form-group>
                        </b-form>
                    </div>
                </template>
            </b-sidebar>
        </div>
    </div>
</div>
</template>

<script>
import {
    paramsFromQuery,
    decodeMeetingSearchParams
} from "@/assets/scripts/utility.js";
import {
    Datetime
} from 'vue-datetime';
import Multiselect from 'vue-multiselect';
import qs from "qs";
export default {
    name: 'DailyStandUp',
    components: {
        datetime: Datetime,
        Multiselect
    },
    data() {
        return {
            GetAllMeetings: [],
            Filter: this.$route.query.search_query,
            total: 0,
            perPage: 0,
            settingsData: {},
            AdvancedFilterMeeting: {
                start_date: null,
                end_date: null,
                tl_id: [],
                user_ids: [],
                signing_off_done: null
            },
            FieldExecutiveList: [],
            teamLeadList: [],
            isTimeExpired: false,
            VisitedList: [
                {
                    value: true,
                    text: 'Yes'
                },
                {
                    value: false,
                    text: 'No'
                }
            ],
        }
    },
    created() {
        sessionStorage.removeItem("isFromMyMeetings");
        this.FetchAllMeetings();
    },
    watch: {
        $route(to, from) {
            this.FetchAllMeetings();
        },
    },
    mounted() {
        let now = new Date();
        let hours = now.getHours();
        let minutes = now.getMinutes() / 100;
        let time = hours + minutes;
        this.isTimeExpired = false;
        this.getFiltersData();
    },
    methods: {
        getFiltersData() {
            this.$axios.get(`daily_stand_ups/settings`).then((result) => {
                this.settingsData = result.data;
                this.FieldExecutiveList = this.settingsData.field_executives;
                this.teamLeadList = this.settingsData.team_leads;
            });
        },
        FetchAllMeetings() {
            let queryP = {}
            let advSearchParams;
            paramsFromQuery(queryP, this.$route.query);
            if (this.$route.query.is_advanced_search) {
                let searchParams = this.$route.query
                for (let key in searchParams) {
                    queryP[key] = searchParams[key];
                }
                advSearchParams = queryP
            }
            if (advSearchParams) {
                paramsFromQuery(queryP, advSearchParams);
            } else {
                paramsFromQuery(queryP, this.$route.query);
            }
            this.$axios.get(`/daily_stand_ups`, {
                params: queryP,
                paramsSerializer: (params) =>
                    qs.stringify(params, {
                        arrayFormat: "brackets"
                    }),
            }).then((res) => {
                this.GetAllMeetings = res.data.daily_stand_up;
                this.perPage = res.data.per_page;
                this.total = res.data.total_count;
            });
        },
        AdvancedFilter() {
            const sendData = decodeMeetingSearchParams(this.AdvancedFilterMeeting);
            let newQ = {
                ...sendData,
                is_advanced_search: true
            };
            this.$router.replace({
                query: newQ
            });
        },
        resetAdvancedFilter() {
            this.AdvancedFilterMeeting = {
                start_date: null,
                end_date: null,
                team_lead: null,
                field_executives: []
            };
            let rQ = this.$route.query
            if (rQ.is_advanced_search) {
                this.$router.replace({
                    query: {}
                });
            }
        },
        resetFilter() {
            let rQ = this.$route.query;
            this.Filter = "";
            if (rQ.search_query) {
                let {
                    search_query,
                    ...newQ
                } = rQ;
                this.$router.replace({
                    query: newQ
                });
            }
        },
        FilterData() {
            if (this.Filter) {
                let newQ = {
                    ...this.$route.query,
                    search_query: this.Filter
                };
                this.$router.replace({
                    query: newQ
                });
            }
        },
        goToPage(pageNo) {
            let newQ = {
                ...this.$route.query,
                pageNo
            };
            this.$router.replace({
                query: newQ
            });
        }
    },
    computed: {
        totalPages() {
            if (this.total === 0 || this.perPage === 0) {
                return 0;
            } else {
                return Math.ceil(this.total / this.perPage);
            }
        },
        pageNo: {
            get() {
                let pageNo = this.$route.query.pageNo || 1
                return parseInt(pageNo);
            },
            set() {
                true;
            }
        },
        pageStart() {
            if (this.total === 0) {
                return 0;
            }
            return (Math.max(0, (this.pageNo - 1) * this.perPage + 1))
        },
        pageEnd() {
            if (this.total === 0) {
                return 0;
            }
            return (Math.min(this.total, this.pageNo * this.perPage))
        },
    }
}
</script>

<style>

</style>
